import moment from 'moment';
import { strToNumber } from 'common/utils/numbers';

export const transformValues = values => {
  const orderedValues = values.map(el => {
    return {
      ...el,
      value_date: moment(el.value_date, 'YYYY-MM-DD')
    };
  });

  return orderedValues;
};

export const formattedValue = value => {
  return strToNumber(value).toLocaleString('en', {
    maximumFractionDigits: 4
  });
};
